var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div>\n<div class=\"row\">\n<div class=\"card-info-icon col-xs-2 col-md-1 pull-right\" ng-if=\"$ctrl.showInfo\" ng-click=\"$ctrl.onServiceInfoClicked($event)\">\n<span class=\"icon icon-26 icon-i pull-right\"></span>\n</div>\n<div class=\"col-xs-10 col-md-8\">\n<div class=\"oral-service-name service-list-item__title\">\n{{$ctrl.service.name}}\n</div>\n</div>\n</div>\n</div>\n";
var id1="app/services/service-list-item-info.tpl.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;